/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.5.0-nightly.2026.7.31",
    versionName: "0.5.0-nightly.2026.7.31",
    versionChannel: "nightly",
    buildDate: "2026-07-31T00:28:35.115Z",
    commitHash: "3000d2e2d8ccc187f9d4929a847af472bc64fb1b",
};
